<template>
  <div class="component-wrapper">
    <div class="form-wrapper">
      <div>
        <p>User Code: {{ userCode }}</p>
      </div>
      <div>
        <label for="userFirstName">First Name: </label>
        <input type="text" id="userFirstName" v-model="userFirstName">
      </div>
      <div>
        <label for="userLastName">Last Name: </label>
        <input type="text" id="userLastName" v-model="userLastName">
      </div>
      <div>
        <label for="userEmail">Email Address: </label>
        <input type="email" id="userEmail" v-model="userEmail">
      </div>
      <div>
        <label for="userLastName">Role: </label>
        <select v-model="userRole">
          <option disabled value="">Please select one</option>
          <option value="admin">CCS Admin</option>
          <option value="trainer">CCS Trainer</option>
          <option value="coordinator">District Coordinator</option>
          <option value="teacher">District Teacher</option>
        </select>
      </div>
    </div>
    <button type="button" @click.prevent="addNewUser">Create New User</button>
    <button type="button" @click.prevent="cancel">Cancel</button>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const fb = require('./../../firebase/firebase')

export default {
  data() {
    return {
      userCode: '',
      userFirstName: '',
      userLastName: '',
      userEmail: '',
      userRole: '',
      verified: false,
      active: true
    }
  },
  computed: {
    ...mapState([ 'districtId' ])
  },
  methods: {
    fetchUserCode() {
      fb.userCodesCollection.where("status", "==", 'available').limit(1).get().then((snap) => {
        snap.forEach((doc) => {
          console.log(doc.id)
          this.userCode = doc.id
        })
      }).then(() => {
        fb.userCodesCollection.doc(this.userCode).update({
          status: 'hold',
          statusUpdated: new Date()
        })
      }).catch((err) => {
        console.log('Error getting code: ', err)
      })
    },
    addNewUser() {
      fb.usersCollection.add({
        userCode: this.userCode,
        userFirstName: this.userFirstName,
        userLastName: this.userLastName,
        userEmail: this.userEmail,
        userRole: this.userRole,
        verified: this.verified,
        active: this.active,
        districtId: this.districtId
      }).then(() => {
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
      }).catch((err) => {
        console.log('error creating user: ', err)
      })
    },
    cancel() {
      fb.userCodesCollection.doc(this.userCode).update({
        status: 'available'
      }).then(() => {
        this.$store.commit('SET_ADMIN_WHICH_COMPONENT', 'manageUsers')
      })
    }
  },
  mounted() {
    this.fetchUserCode()
  }
}
</script>

<style lang="css" scoped>
</style>
